import { render, staticRenderFns } from "./phonogram-manager.vue?vue&type=template&id=6f3789dc&scoped=true"
import script from "./phonogram-manager.ts?vue&type=script&lang=ts&external"
export * from "./phonogram-manager.ts?vue&type=script&lang=ts&external"
import style0 from "./phonogram-manager.less?vue&type=style&index=0&id=6f3789dc&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3789dc",
  null
  
)

export default component.exports